<!-- 法律-角色选择 -->
<template>
    <div class="law-role-select">
        <div class="title"></div>
        <div class="btns">
            <div class="law-firm">
                <div class="law-img" @click="selectLawFirm"></div>
                <div class="law-tip">
                    若您为律所管理者、律所合伙人，您可以选择以律所或者团队身份入驻，入驻后将获得律所品牌曝光、律所成员曝光、律所案源管理、律所内容管理等专享权益。
                    <div class="high-light">注意：以律所身份入驻需要律所授权</div>
                </div>
            </div>
            <div class="lawyer">
                <div class="law-img" @click="selectLawyer"></div>
                <div class="law-tip">
                    若您为个体律师，您可以选择律师合作，入驻后将获得律师曝光、内容引流、案源挑选等律师专属权益，无需律所授权
                </div>
            </div>
        </div>
    </div>
</template>

<script>
/**
 * @file 法律-角色选择
 * @description 法律-角色选择
 * @author dingzhenyue@baidu.com
 */
export default {
    data() {
        return {};
    },
    mounted() {
        // 曝光打点
        this.$log
            && this.$log.send({
                type: 'show',
                value: 'law-role-select',
                page: 'filldata'
            });
    },
    methods: {
        selectLawFirm() {
            this.$emit('selectLawFirm');
            this.$log
                && this.$log.send({
                    type: 'clk',
                    value: 'law-firm-select',
                    page: 'filldata'
                });
        },
        selectLawyer() {
            this.$emit('selectLawyer');
            this.$log
                && this.$log.send({
                    type: 'clk',
                    value: 'lawyer-select',
                    page: 'filldata'
                });
        }
    }
};
</script>

<style lang='less' scoped>
.law-role-select {
  padding-top: 88px;

  .title {
    margin: 0 auto;
    width: 427px;
    height: 77px;
    background: url("https://lvlin-base.cdn.bcebos.com/bend/filldata/law-select-title.png")
      no-repeat center center / 100% 100%;
  }

  .btns {
    display: flex;
    margin: 52px 0 94px;
    justify-content: center;

    .law-img {
        cursor: pointer;
        width: 487px;
        height: 255px;
    }
    .law-tip {
        padding: 0 10px;
        width: 447px;
        margin-top: 20px;
        text-align: left;
        box-sizing: border-box;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #999999;
        letter-spacing: 0;
        line-height: 18px;
        font-weight: 400;

        .high-light {
            margin-top: 4px;
            color: #F38734;
        }
    }

    .law-firm {
        .law-img {
            background: url("https://lvlin-base.cdn.bcebos.com/bend/filldata/lawfirm-btn.png")
              no-repeat center bottom / 100% 100%;
        }
    }

    .lawyer {
        .law-img {
            margin-left: 42px;
            background: url("https://lvlin-base.cdn.bcebos.com/bend/filldata/lawyer-btn.png")
                no-repeat center bottom / 100% 100%;
        }
        .law-tip {
            margin-left: 82px;
        }
    }
  }
}
</style>
